import utils from '../../utils'
import NotifyMsg from './NotifyMsg'
import BinaryWriter from './BinaryWriter'

const NotifyClient = function(opts) {
    opts = opts || {};
    this.$config = opts.config;
    this.$user = opts.user;
    this.$ws = null;
    this.$connectPromise = null;
    this.$actions = {};
    this.$count = 0; //订阅数量
    this.$reconnectInterval = 0; //重连间隔时间
    utils.WildEmitter.call(this);
};

const pt = NotifyClient.prototype;

utils.WildEmitter.mixin(NotifyClient);

// 获取消息通知的地址
pt.getNotifyUrl = function() {
    return this.$config.getValue('notify.url', '');
};

// 获取代理的地址
pt.getProxyUrl = function() {
    return this.$config.getValue('notify.proxy', '');
};

//连接消息服务
pt.connect = function() {
    if (this.$ws) {
        return Promise.resolve(this.$ws);
    }
    else if (this.$connectPromise) {
        return this.$connectPromise;
    }
    else {
        const that = this;
        this.$connectPromise = 
        new Promise(function (resolve, reject) {
            const url = that.getNotifyUrl();
            if (!url) {
                console.error('No notify url');
                reject('No notify url');
                return;
            }
            const ws = new WebSocket(url);
            ws.binaryType = 'arraybuffer';
            const onmsg = function(e) {
                that.onmsg(e);
            };
            const onopen = function() {
                that.$ws = ws;
                that.$connectPromise = null;
                that.$reconnectInterval = 0; //重连间隔时间
                //console.debug('Connected ' + url);
                that.updateSubscripts();
                that.emit('open');
                resolve(ws);
            };
            const onclose = function() {
                that.$ws = null;
                that.$connectPromise = null;
                ws.removeEventListener('open', onopen);
                ws.removeEventListener('close', onclose);
                ws.removeEventListener('error', onerror);
                ws.removeEventListener('message', onmsg);
                that.emit('close');
                // 1 秒后重连
                if (that.$count > 0) {
                    if (!that.$reconnectInterval) {
                        that.$reconnectInterval = 1000;
                    }
                    else if (that.$reconnectInterval < 10 * 60 * 1000) { //小于 10 分钟，则延长重连时间
                        that.$reconnectInterval = parseInt(that.$reconnectInterval * 1.382);
                    }
                    setTimeout(()=>{
                        //console.debug('Reconnect ' + url);
                        that.connect();
                    }, that.$reconnectInterval);
                }
            };
            const onerror = function(err) {
                console.error(err);
                that.emit('error', err);
                onclose();
                reject(err);
            };
    
            ws.addEventListener('open', onopen);
            ws.addEventListener('close', onclose);
            ws.addEventListener('error', onerror);
            ws.addEventListener('message', onmsg);
        });
        return this.$connectPromise;
    }
};

//清空订阅
pt.clear = function() {
    this.emit('clear');
    this.$actions = {};
    this.$count = 0;
    if (this.$ws) {
        this.updateSubscripts();
    }
};

//关闭连接
pt.close = function() {
    this.$actions = {};
    this.$count = 0;
    if (this.$ws) {
        this.$ws.close();
        this.$ws = null;
    }
    else if (this.$connectPromise) {
        this.$connectPromise.then(function(ws) {
            ws.close();
        });
    }
};

//获取请求 Token
pt.getToken = function() {
    const token = this.$user ? this.$user.getNotifyToken() : '';
    if (token) {
        return utils.stringToUtf8ByteArray(token);
    }
    else {
        return [];
    }
};

//更新远程服务器上的订阅数据库
pt.updateSubscripts = function() {
    //订阅
    let data = [];
    let writer = new BinaryWriter(data);
    utils.each(this.$actions, x=>{
        if (x.callback.length > 0) {
            writer.writeString(x.key);
        }
    });
    const msg = NotifyMsg.wrap('UpdateSubscript', data, this.getToken());
    msg.header.cmd = NotifyMsg.CMD_UPDATE_SUBSCRIPT;
    msg.header.cmdParam = 0;
    const pkg = msg.getArrayBuffer();
    this.$ws.send(pkg);
};

//接收到消息
pt.onmsg = function(e) {
    const that = this;
    if (!this.$ws) return;
    const msg = NotifyMsg.parseFromArrayBuffer(e.data);
    if (msg.header.cmd == NotifyMsg.CMD_BROADCAST &&
        msg.header.cmdParam == 0) {
        that.emit('msg', msg);
        that.dispatch(msg);
    }
    //else {
    //    console.debug(NotifyMsg.getCmdName(msg.header.cmd) +
    //        (msg.header.cmdParam ? '成功' : '失败') + ', key=' + msg.key);
    //}
};

//分发消息
pt.dispatch = function(msg) {
    const key = msg.key || '';
    const act = this.$actions[key];
    const that = this;
    if (typeof act === 'undefined') {
        return;
    }
    utils.each(act.callback||[], (x)=>{
        if (typeof x === 'function') {
            x.apply(that, [msg]);
        }
    });
};

//订阅
pt.subscript = function(key, callback) {
    let act = this.$actions[key];
    if (typeof act === 'undefined') {
        act = {
            key: key,
            callback: []
        };
        this.$actions[key] = act;
    }
    act.callback.push(callback);
    this.$count++;
    this.emit('subscript', {
        key: key,
        callback: callback
    });
    if (this.$ws) {
        this.updateSubscripts();
    }
    else {
        this.connect();
    }
};

//反订阅
pt.unsubscript = function(key, callback) {
    this.emit('unsubscript', {
        key: key,
        callback: callback
    });
    let act = this.$actions[key];
    if (typeof act !== 'undefined') {
        if (callback) {
            let indexs = [];
            //找到待删除元素
            utils.each(act.callback, (x,i)=>{
                if (x === callback) {
                    indexs.push(i);
                }
            });
            utils.each(indexs.reverse(), x=>{
                act.callback.splice(x, 1);
                this.$count--;
            });
            if (act.callback.length == 0) {
                delete this.$actions[key];
            }
        }
        else {
            delete this.$actions[key];
            this.$count -= act.callback.length;
        }
        if (this.$ws) {
            this.updateSubscripts();
        }
    }
};

//广播消息
// key - 消息 Key
// msg - 消息内容, JSON 格式：
//       {
//           key: String,
//           data: String|ArrayBuffer|Byte[]
//       }
pt.broadcase = function(msg) {
    if (!msg) {
        throw new Error('"msg" can not be empty');
    }
    if (!msg.key) {
        throw new Error('"msg.key" can not be empty');
    }
    this.emit('broadcase', msg);
    const wsmsg = NotifyMsg.wrap(msg.key, msg.data, this.getToken());
    wsmsg.header.cmd = NotifyMsg.CMD_BROADCAST;
    wsmsg.header.cmdParam = 0;
    const pkg = wsmsg.getArrayBuffer();
    if (this.$ws) {
        this.$ws.send(pkg);
    }
    else {
        this.connect().then(ws=>{
            ws.send(pkg);
        });
    }
};

export default NotifyClient;
